import { truncateHash } from "../utils";
import { CopyText } from "./CopyText";
export function CopyHash({ hash, ...textProps }) {
    return (<CopyText value={truncateHash(hash)} copyValue={hash} {...textProps}/>);
}
//# sourceMappingURL=CopyHash.jsx.map